import React from 'react';
import { Info, Package, ArrowLeft } from 'lucide-react';

export type ProductOptionGroupTabId = 'info' | 'products';

interface ProductOptionGroupFormLayoutProps {
  activeTab: ProductOptionGroupTabId;
  onTabChange: (tab: ProductOptionGroupTabId) => void;
  groupCode: string | null;
  onBackClick: () => void;
  children: React.ReactNode;
}

const TABS: { id: ProductOptionGroupTabId; label: string; icon: React.ReactNode }[] = [
  { id: 'info', label: '옵션그룹 정보', icon: <Info className="w-4 h-4" /> },
  { id: 'products', label: '상품 선택', icon: <Package className="w-4 h-4" /> },
];

const ProductOptionGroupFormLayout: React.FC<ProductOptionGroupFormLayoutProps> = ({
  activeTab,
  onTabChange,
  groupCode,
  onBackClick,
  children,
}) => {
  const isProductsTabEnabled = !!groupCode;

  return (
    <div className="space-y-6">
      <div className="mb-4">
        <button
          type="button"
          onClick={onBackClick}
          className="flex items-center text-sm text-gray-600 hover:text-gray-900 transition-colors"
        >
          <ArrowLeft className="w-4 h-4 mr-1" />
          옵션그룹 목록으로
        </button>
      </div>

      <div className="border-b border-gray-200">
        <nav className="flex gap-1" aria-label="탭">
          {TABS.map((tab) => {
            const disabled = tab.id === 'products' && !isProductsTabEnabled;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => !disabled && onTabChange(tab.id)}
                disabled={disabled}
                title={disabled ? '옵션그룹 정보를 먼저 저장해주세요.' : undefined}
                className={`
                  flex items-center gap-2 px-4 py-3 text-sm font-medium rounded-t-lg border-b-2 -mb-px transition-colors
                  ${isActive
                    ? 'border-blue-600 text-blue-600 bg-blue-50'
                    : disabled
                      ? 'border-transparent text-gray-400 cursor-not-allowed'
                      : 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50 hover:border-blue-600'
                  }
                `}
              >
                {tab.icon}
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>

      <div>{children}</div>
    </div>
  );
};

export default ProductOptionGroupFormLayout;